import React from 'react';


class PickerTemplate extends React.Component {
    constructor(props) {
        super(props);  

        this.renderImage = this.renderImage.bind(this);
    }

    renderImage() {
        let image = '/images/picker/custom.png';
        if(this.props.template.custom == 1) {
            if(this.props.template.image != 'loading' && this.props.template.image) {
                image = this.props.template.image;
            }
        }else{
            if(this.props.template.owner_email.image && this.props.template.owner_email.image != 'loading') {
                image = this.props.template.owner_email.image;
            }
        }

        return image;
    }



    render() {

        return (
            <div className="card card-shadow">
                <div className="text-center card-header card-header-transparent card-header-bordered white p-30">
                    {
                        this.props.type == 'email' ?
                            <img src={this.renderImage()} style={{width:'400px'}} />
                            :
                            <img src={`/images/picker/${(this.props.template.custom == '1' ? 'custom':this.props.item)}.png`} style={{width:'250px'}} />
                    }
                </div>
                <div className="card-block">
                   <button className="btn btn-block btn-dark" onClick={(e) => {e.stopPropagation(); this.props.onSelect((this.props.template.custom == '1' ? this.props.item+'-custom':this.props.item))}} style={{borderRadius:0}}>Select {(this.props.template.custom == '1' ? '"'+this.props.template.title+'"':null)}</button>
                </div>
            </div>


        );
    }

  
}

export default PickerTemplate;




// WEBPACK FOOTER //
// ./components/builder/PickerTemplate.js